import { render, staticRenderFns } from "./ProfileProducts.vue?vue&type=template&id=a6d46b16&"
import script from "./ProfileProducts.vue?vue&type=script&lang=js&"
export * from "./ProfileProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports